import React, {useState, useEffect} from 'react';
import Container from 'react-bootstrap/Container';
import Axios from 'axios'
import Button from 'react-bootstrap/Button';

import {ImageTextWrapper} from '../ImageTextWrapper/ImageTextWrapper';
import {IIIFImageLogo} from '../IIIFImageLogo';
import {OSDInstance} from '../OSDInstance';

import {runQuery} from '../utils'
import {getSurfaceInfo} from './queries'

interface MyComponentProps {
  surfaceid: string,
  handleChangeInfo?: any,
  annotationsDisplay?: boolean,
  lineFocusId?: string,
  handleLineFocusChange?: any,
  targetLabel?: string,
  width?: string
}

export const Surface2: React.FC<MyComponentProps> = (props) => {

  const [currentSurfaceId, setCurrentSurfaceId] = useState<string>("")
  const [surfaceTitle, setSurfaceTitle] = useState<string>("")
  const [manifest, setManifest] = useState<string>("")
  const [canvas, setCanvas] = useState<string>("")
  const [region, setRegion] = useState<string>("full")
  const [width, setWidth] = useState<string>("1000")
  const [next, setNext] = useState<string>("")
  const [previous, setPrevious] = useState<string>("")
  const [imageurl, setImageurl] = useState<string>("")
  const [annotations, setAnnotations] = useState<any>([])
  const [annotationsDisplay, setAnnotationsDisplay] = useState<boolean>(props.annotationsDisplay || false)
  const [showAllLines, setShowAllLines] = useState<boolean>(false)
  

  const handleNext = () => {
    props.handleChangeInfo(next)
  }
  const handlePrevious = () => {
    props.handleChangeInfo(previous)
  }
  const handleToggleTextLines = () => {
    setAnnotationsDisplay(!annotationsDisplay)
  }
  const handleToggleAllLines = () => {
    setShowAllLines(!showAllLines)
  }
  const retrieveSurfaceInfo = (surfaceid: string) => {
    // manifest id should be retrieved from query
    // this is a temporary measure until db is corrected and query is posible
    //const manifest = "http://scta.info/iiif/" + this.props.topLevel.split("/resource/")[1] + "/" + surfaceid.split("/resource/")[1].split("/")[0] + "/manifest";
    const manifest = "";
    const surfaceInfo = runQuery(getSurfaceInfo(surfaceid))
    surfaceInfo.then((d) => {
      const b = d.data.results.bindings[0]
      // only preceed if sparql query returns results
      if (b){
        //second nested async call for annotation list
        const alUrl = "https://exist.scta.info/exist/apps/scta-app/folio-annotaiton-list-from-simpleXmlCoordinates.xq?surfaceid=" + surfaceid.split("/resource/")[1] + "&coords=loose"
        Axios.get(alUrl).then((d2) => {
          setCurrentSurfaceId(surfaceid)
          setSurfaceTitle(b.surfaceTitle.value)
          setManifest(manifest)
          setCanvas(b.canvas.value)
          setImageurl(b.imageurl.value)
          setNext(b.next_surface ? b.next_surface.value : "")
          setPrevious(b.previous_surface ? b.previous_surface.value : "")
          setAnnotations(d2.data ? d2.data: "")
        }).catch((error) => {
          console.log("failed retrieving annotationlist: ", error)
          setCurrentSurfaceId(surfaceid)
          setSurfaceTitle(b.surfaceTitle.value)
          setManifest(manifest)
          setCanvas(b.canvas.value)
          setImageurl(b.imageurl.value)
          setNext(b.next_surface ? b.next_surface.value : "")
          setPrevious(b.previous_surface ? b.previous_surface.value : "")
          setAnnotations("")
      })
    }
  })
}
// next for functions are used to compute next and previous Lines
// this is a little bit hacky, since there are no resources for lines yet.
// thus the line id is computed by breaking the line id apart,
// using the line number to compute the next and the reassembling the line RDF id.
// this will become unnecessary if/when each lines become and RDF resource and contains a next previous property
const handleLineFocusNext = () => {
  const currentLineNumber = props.lineFocusId && parseInt(props.lineFocusId.split("/")[props.lineFocusId.split("/").length - 1]) || 0
  const newLineArray = props.lineFocusId && props.lineFocusId.split("/") || []
  newLineArray.pop()
  newLineArray.push((currentLineNumber + 1).toString())
  props.handleLineFocusChange(newLineArray.join("/"))
}
const handleLineFocusPrev = () => {
  const currentLineNumber = props.lineFocusId && parseInt(props.lineFocusId.split("/")[props.lineFocusId.split("/").length - 1]) || 0 
  const previousLineArray = props.lineFocusId && props.lineFocusId.split("/") || []
  previousLineArray.pop()
  previousLineArray.push((currentLineNumber - 1).toString())
  props.handleLineFocusChange(previousLineArray.join("/"))
}
const isLineNumberFirst = () => {
  const lineNumber = props.lineFocusId && parseInt(props.lineFocusId.split("/")[props.lineFocusId.split("/").length - 1])

  if (lineNumber === 1){
    return true
  }
  else {
    return false
  }
}
const isLineNumberLast = () => {
  const total = annotations ? annotations.length : ""
  const lineNumber = props.lineFocusId && parseInt(props.lineFocusId.split("/")[props.lineFocusId.split("/").length - 1])
  if (lineNumber === total){
    return true
  }
  else{
    return false
  }
}
useEffect(() => {
  if (props.surfaceid){
    retrieveSurfaceInfo(props.surfaceid)
  }
}, [props.surfaceid])


  const displayImage = (h, i) => {
    const text = h.resource.chars;
    const canvas = h.on.split("#xywh=")[0];
    const canvasShort = canvas.split("/")[canvas.split("/").length - 1];
    const coords = h.on.split("#xywh=")[1];
    const imageUrl = h.imageUrl
    const label = h.label
      if (showAllLines || (props.lineFocusId && parseInt(props.lineFocusId?.split("/")[props.lineFocusId?.split("/").length - 1]) === (i + 1) ) || !props.lineFocusId){
        return (
          <ImageTextWrapper key={i}
            imageurl={imageUrl}
            canvas={canvas}
            coords={coords}
            canvasShort={canvasShort}
            text={text}
            label={label}
            number={i + 1}
            targetLabel={props.targetLabel}
            surfaceButton={false}
            viewerWidth={props.width ? props.width : width}
            />
          )
        }
        else{
          return null
        }

      }
      const displayImages = () => {
        if (annotations && annotationsDisplay){
          let imageTextWrappers: any[] = []
          if (!annotations.resources.length){
            const imageResult = displayImage(annotations, 0)
            imageTextWrappers = imageResult
          }
          else{
            imageTextWrappers = annotations.resources.map((h, i) => {
              return displayImage(h, i)
            });
          }
          return imageTextWrappers
        }
        else{
          //TODO uncommnent when ready to make a switch between using OSD or Image
          //const width = this.props.width ? this.props.width : this.state.width
          //return <img alt="manuscript" src={this.state.imageurl + "/" + this.state.region + "/" + width + ",/0/default.jpg"}/>
          return <OSDInstance imageurl={imageurl} viewerHeight={800}/>
        }
      }

      return (
        <Container >
        {currentSurfaceId ?
          <div>
            <div className="surface-navigation">
              <p>{surfaceTitle}</p>
              {(props.handleChangeInfo) &&
                <div>
                {previous && <Button size="sm" onClick={handlePrevious}>Previous Page</Button>}
                {next && <Button size="sm" onClick={handleNext}>Next Page</Button>}
                </div>
              }
              {(props.handleLineFocusChange && !showAllLines) &&
                <div>
                {!isLineNumberFirst() && <Button size="sm" onClick={handleLineFocusPrev}>Previous Line</Button>}
                {!isLineNumberLast() && <Button size="sm" onClick={handleLineFocusNext}>Next Line</Button>}
                </div>
              }
              <div>

              {props.lineFocusId && <Button size="sm" onClick={handleToggleAllLines}>Toggle All/Focus Lines</Button>}
              {(annotations) && <Button size="sm" onClick={handleToggleTextLines}>Toggle Show Text Lines</Button>}
              </div>
              <IIIFImageLogo imageurl={imageurl}/>
            </div>
            {displayImages()}
          </div> : <p>No surface selected</p>}
        </Container>

      );
    }

